export default "<router-outlet></router-outlet>\n<app-home></app-home>\n<ngx-ui-loader text=\"Yükleniyor...\"></ngx-ui-loader>\n"